export interface Testimonial {
  role: string
  location: string
  text: string
  /** true until replaced with verified customer feedback */
  isSample: boolean
}

// Placeholder copy for layout only — replace with verified customer feedback before publication
// and set isSample to false.
export const shortTestimonials: Testimonial[] = [
  {
    role: 'Scuba Instructor',
    location: 'United States',
    text: 'Having the lesson structure already organized makes my preparation much easier. I can choose the skill, review the visual progression and know exactly what I want the student to practice.',
    isSample: true,
  },
  {
    role: 'Dive Educator',
    location: 'Australia',
    text: 'The visual explanations are what stand out most. Buoyancy, trim and positioning become much easier to explain when students can actually see the difference between correct and incorrect technique.',
    isSample: true,
  },
  {
    role: 'Scuba Instructor',
    location: 'United Kingdom',
    text: 'The progressions, correction tools and assessments give my sessions much more structure. I spend less time planning and more time actually teaching.',
    isSample: true,
  },
]
